<template>
    <div>
        <el-dialog :title="title" :visible.sync="visible.isShow" width="800px" @close="cancel('form')" center>
            <el-form :model="form" label-width="160px" :rules="rules"  ref="form">
                <el-form-item label="转办供应商名称" prop="supplierId">
                    <el-select v-model="form.supplierId" style="width:100%;" filterable>
                        <el-option v-for="li in supplierList" :label="li.name" :value="li.id" :key="li.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="费率" prop="rate">
                    <el-input v-model="form.rate" placeholder="请输入费率"></el-input>
                </el-form-item>
            </el-form>
            <div class="btn-group">
                <el-button type="primary" @click="submit('form')">提交</el-button>
                <el-button @click="cancel('form')">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props:{
        visible:{
            type:Object,
            default:()=>{
                return { isShow:false }
            }
        },
        info:{
            type:Object,
            default:()=>{
                return {}
            }
        },
        supplierList:{
            type:Array,
            default:()=>{
                return []
            }
        },
    },
    data(){
        return {
            form:{
                supplierId:'',
                rate:'',

            },
            rules:{
                supplierId:[
                    { required:true,message:'请选择转办供应商',trigger:'change'},
                ],
                rate:[
                    { required:true,message:'请输入费率',trigger:'blur'},
                    { pattern: /^[0-9]+(\.[0-9]{0,2})?$/ ,message:'只能输入大于0的最多两位小数', trigger:'blur'}
                ]
            }
        }
    },
    created(){
        console.log(this.info,3333)
        this.form = Object.assign({},this.form,this.info);
    },
    computed:{
        title(){
            if(!this.info.supplierId){
                return '转办';
            }
            return '重新转办';
        }
    },
    methods:{
        cancel(formName){
            this.$refs[formName].resetFields();
            this.visible.isShow = false;
        },

        submit(formName){
            this.$refs[formName].validate(valid =>{
                if(valid){
                    let params = {
                        supplierId:this.form.supplierId,
                        fid:this.info.fid,
                        rate:this.form.rate
                    }
                    if(params.fid){
                        this.$http.post('rest/api/contract/saveSupplier',params).then(data =>{
                           this.$message.success(data.data.message || '操作成功');
                           this.$emit('update')
                           this.cancel(formName);
                       })
                    }
                }
            })
        }
    },

}
</script>

<style scope>
    .btn-group{
        text-align: center;
    }

</style>



// WEBPACK FOOTER //
// src/pages/dsp/contract/transferSupplierDialog.vue